import { AsyncPipe } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Meta } from '@angular/platform-browser';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-warranty',
  templateUrl: './warranty.component.html',
  styleUrls: ['./warranty.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatIcon, AsyncPipe],
})
export class WarrantyComponent {
  data$: Observable<any> = this.component.data$;
  mediaUrl$: Observable<any> = this.component.data$.pipe(
    map((data) => (data.hasOwnProperty('localizedMedia') ? data.localizedMedia.url : data.media.url))
  );
  baseUrl = this.meta.getTag('name=occ-backend-base-url').content;

  constructor(public component: CmsComponentData<any>, private meta: Meta) {}

  mediaUrl(url: string): any {
    return url.startsWith('/medias') ? this.baseUrl + url : url;
  }
}
